import { SITE_COPY } from './copy';

/**
 * The rotating hero headline, from content/site.json.
 *
 * Each entry is exactly two lines, so the headline block keeps a constant
 * height and the page below it never jumps as the phrase changes.
 *
 * The first entry is what renders in the static HTML and what a visitor with
 * JavaScript disabled sees, so it should be the one that names the shop.
 *
 * Keep them short. The headline is set at up to 80px, and a third line would
 * push the opening paragraph below the fold on a phone.
 */
export const HEADLINES: readonly (readonly [string, string])[] = SITE_COPY.headlines.map(
  (h) => [h.line1, h.line2] as const,
);

/** How long each phrase holds before the next one rises. */
export const HEADLINE_INTERVAL_MS = 5000;
